import * as React from 'react';
import { MaterialFontIcon, MaterialIconName } from '../../../../commonv3/components/atoms/icons/icons';
import classNames from 'classnames';
import './mainTab.module.scss';

type ListProps = {
    className?: string;
    styleName?: string;
    children: any;
};

export const MainTabList = ({ children, className }: ListProps) => (
    <div styleName="main-tab-list" className={className}>
        {children}
    </div>
);

type Props = {
    id?: string;
    iconName: MaterialIconName;
    title: string;
    selected: boolean;
    onSelect: () => any;
};
export const MainTab = ({ id, iconName, title, selected, onSelect }: Props) => {
    return (
        <div id={id} styleName={classNames('main-tab', { selected: selected })} onClick={onSelect}>
            <div styleName="icon-wrapper">
                <MaterialFontIcon name={iconName} styleName="icon" />
            </div>
            <div styleName="title">{title}</div>
        </div>
    );
};
